/* <read-more> — uzun metni kısaltır, "Devamını oku" / "Daha az göster" ile açar. Taşma yoksa buton gizli kalır. */
if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-read-more-content]');
      this.btn = this.querySelector('[data-read-more-toggle]');
      if (!this.content || !this.btn) return;
      this.label = this.btn.querySelector('[data-read-more-label]') || this.btn;
      this.classList.add('is-collapsible');
      this.btn.addEventListener('click', () => this.toggle());
      this.measure();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.measure());
        this.ro.observe(this);
      }
    }
    disconnectedCallback() {
      this.ro?.disconnect();
    }
    measure() {
      if (this.classList.contains('is-expanded')) return;
      const overflow = this.content.scrollHeight > this.content.clientHeight + 2;
      this.btn.hidden = !overflow;
      this.classList.toggle('is-overflowing', overflow);
    }
    toggle() {
      const expanded = !this.classList.contains('is-expanded');
      this.classList.toggle('is-expanded', expanded);
      this.btn.setAttribute('aria-expanded', expanded);
      this.label.textContent = expanded ? this.dataset.labelLess : this.dataset.labelMore;
      if (!expanded) this.measure();
    }
  }
  customElements.define('read-more', ReadMore);
}
